import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFadeObserver } from '../../hooks/fadeObserver.hook';
import { PricingElement } from './PricingElement';

const PricingComponent = ({ pricingRule: rawPricingRule }) => {
  const refPricing = useRef(null);

  useFadeObserver(refPricing);

  const pricingRule = useMemo(
    () =>
      rawPricingRule || {
        monthly_fee: 799,
        free_shipping: true,
        discount_proportion: 0.9,
        first_bag_discount: 0.8,
        free_trial_length: 30,
      },
    [rawPricingRule]
  );

  return (
    <>
      <div className="bg-blue-gradient text-white text-center p-5 rounded mb-30px fade-on-screen" ref={refPricing}>
        <div className="pricing-heading">30 days free, then</div>
        <div className="font-weight-bold pricing-price mb-30px">
          $7.99 <span className="font-weight-normal pricing-period">/month</span>
        </div>
        <a href="/filter_checkout" className="btn btn-accent btn-lg">
          Get started
        </a>
      </div>
      <div className="row mb--4 justify-content-center">
        {pricingRule.free_shipping && (
          <PricingElement title="Free shipping" description="No minimum or maximum orders" index={0} />
        )}
        <PricingElement title="Get discounts" description="20% off first bag|10% off future bags" index={1} />
        <PricingElement title="Includes your smart scale" description="Never run out of coffee again" index={2} />
      </div>
    </>
  );
};

PricingComponent.propTypes = {
  pricingRule: PropTypes.object,
};

export const Pricing = connect(({ user }) => ({
  me: user.me,
  pricingRule: user.me ? user.me.pricingRule : user.pricingRule,
}))(PricingComponent);
